module.exports = __webpack_public_path__ + "assets/img/feature_1-b1c99c80.png";